import { Box, ThemeProvider } from '@mui/material';
import ReactDOM from 'react-dom/client';
import 'reflect-metadata';

import App from './App';
import { theme } from './styles/muiTheme';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <Box p={{ xs: 2, lg: 3 }}>
      <App
        accessToken={import.meta.env.VITE_APP_DEV_ACCESS_TOKEN}
        inspectionId={Number(import.meta.env.VITE_APP_DEV_INSPECTION_ID)}
      />
    </Box>
  </ThemeProvider>,
  // </React.StrictMode>,
);
